import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import CarTable from "./CarTable";

import SearchField from "../../table-common/SearchField";
import {filterCarListItems} from "../../table-common/table-search";
import {getCarSortingFunction} from "../../table-common/table-sorting";

const CarListView = ({fleetService, CommonService, CarService, $state}) => {
    const rowSelected = (row) => {
      const trainInState = CommonService.getSelectedTrain();
      if (trainInState) {
        $state.go('car', { carNumber: row.car_id, trainId: trainInState.status.trainId });
      } else {
        $state.go('car', { carNumber: row.car_id, trainId: row.trainId });
      }
    }

    let [selectedTrain, setSelectedTrain] = useState(true);
    let [loadedData, setLoadedData] = useState([]);

    const reorderByTopology = (carData, carIds) => {
      const carMap = new Map(carData.map(car => [car.car_id, car]));
      const ordered = [];
      for (const id of carIds) {
        const car = carMap.get(id);
        if (car) ordered.push(car);
      }
      return ordered;
    };

    const load = async () => {
      const trainInState = CommonService.getSelectedTrain();
      if (trainInState) {
        setSelectedTrain(true);
        const trainParams = {
          consist: trainInState.status.trainId
        };
        const trainCars = await CarService.carListForConsist(trainParams);
        const carParams = {
          carIds: trainCars
        };
        const carData = await fleetService.getCarListStatus(carParams);
        setLoadedData(reorderByTopology(carData, trainCars));
      } else {
        setSelectedTrain(false);
        const carList = await fleetService.getCarList();
        const params = {
          carIds: carList
        };
        const carData = await fleetService.getCarListStatus(params);

        // Sorting expects that a field value is not null
        for (let car of carData) {
          if (!car.trainLineNumber) {
            car.trainLineNumber = '';
          }
        }
        setLoadedData(reorderByTopology(carData, carList));
      }
    };

    useEffect(() => {
      let cancelled = false;

      // If the train is already selected, load immediately.
      // Otherwise, wait for it to become available then load once.
      if (CommonService.getSelectedTrain()) {
        load();
      } else {
        const waitForTrain = () => {
          if (cancelled) return;
          if (!CommonService.getSelectedTrain()) {
            setTimeout(waitForTrain, 50);
            return;
          }
            load();
          };
        setTimeout(waitForTrain, 50);
      }

      return () => {
        cancelled = true;
      };
    }, [fleetService, CommonService, CarService]);

    // Update every 10 seconds
    useEffect(() => {
        const interval = setInterval(load, 10000);
        return () => clearInterval(interval);
    });

    // Sorting state: null means no sorting (use backend order)
    let [sortingBy, setSortingBy] = useState(null);
    let [sortReversed, setSortReversed] = useState(false);
    const changeSort = newType => {
      if (sortingBy === newType) {
        setSortReversed(!sortReversed);
      } else {
        setSortingBy(newType);
        setSortReversed(false);
      }
    };

    let [searchBy, setSearchBy] = useState("");
    let [visibleData, setVisibleData] = useState([]);
    useEffect(() => {
      let filtered = loadedData.filter(filterCarListItems(searchBy));
      // Only sort if user has selected a sort column
      if (sortingBy) {
        filtered = filtered.slice().sort(getCarSortingFunction(sortingBy, sortReversed));
      }
      setVisibleData(filtered);
    }, [loadedData, searchBy, sortingBy, sortReversed]);

    return (
        <div id="car-list-container">
            <div className="page-container">
                {!selectedTrain && <SearchField value={searchBy} setValue={setSearchBy}/>}
                <CarTable
                    data={visibleData}
                    sorting={{sortingBy, sortReversed, changeSort}}
                    rowSelected={rowSelected}
                    selectedTrain={selectedTrain}
                    />
            </div>
        </div>
    );
};

CarListView.propTypes = {
    ConditionService: PropTypes.object,
};

export default CarListView;
